unit Dataset.Plugins;

interface

uses
  SysUtils,
  DB,
  JS,
  WEBLib.DBCtrls,
  XData.Web.Dataset,
  XData.Web.JsonDataset,
  XData.Web.Connection,
  XData.Model.Classes,

  System.Classes, //KSS

  Grid.Settings;

type
  TDatasetPlugin = class;

  TOnLoad = reference to procedure(DatasetPlugin: TDatasetPlugin);

  TDatasetPlugin = class
  strict private
    FDataset: TXDataWebDataSet;
    FOriginalQuery: string;
    FPageSize: integer;
    FPageNumber: integer;
    procedure AddPaginationQueryUrl(Dataset: TXDataWebDataSet; APageNumber: Integer; APageSize: integer);
    procedure AddExpandQueryUrl(Dataset: TXDataWebDataSet);
    procedure AddFilterQueryUrl(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; AFilterText: string; AConstriantText: string = '');
    procedure AddFilterFieldBasedQuery(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; ASearchFields:
      TSearchFields; AFilterText: string; AConstraintText: string = '');
    procedure AddPreparedFilter(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; APreparedFilter: string;
      const AFilterText: string = '');
    function BuildColumnFilterExpression(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; AFilterText: string;
      AConstriantText: string = ''): string;
    procedure AddOrderByQueryUrl(Dataset: TXDataWebDataSet; SortedItems: TSortedItems);
  private
    procedure SetPageSize(const Value: Integer);
    procedure SetPageNumber(const Value: Integer);
    function GetServerRecordCount: Integer;
  private
    // events
    FOnLoad: TOnLoad;
    FOriginalAfterOpen: TDataSetNotifyEvent;
    procedure InternalAfterOpen(ADataset: TDataSet);
  public
    constructor Create(ADataset: TXDataWebDataSet; ALoadCallback: TOnLoad);
    procedure LoadDataset(GridSettings: TGridSettings);
    function IsLastPage: Boolean;
    function PreviousPage: Boolean;
    function NextPage: Boolean;
    property PageSize: Integer read FPageSize write SetPageSize;
    property PageNumber: Integer read FPageNumber write SetPageNumber;
    property ServerRecordCount: Integer read GetServerRecordCount;
  end;

implementation

{ TDatasetPlugin }

procedure TDatasetPlugin.AddPaginationQueryUrl(Dataset: TXDataWebDataSet; APageNumber: Integer; APageSize: integer);
begin
  if APageSize = 0 then
    Exit;
  Dataset.QueryTop := APageSize;
  Dataset.QuerySkip := (APageNumber - 1) * APageSize;
end;

procedure TDatasetPlugin.AddPreparedFilter(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; APreparedFilter: string;
  const AFilterText: string);
var
  QueryUrl: string;
  TextExpr: string;
begin
  if AFilterText <> '' then
  begin
    TextExpr := BuildColumnFilterExpression(Dataset, AGrid, AFilterText);
    if TextExpr <> '' then
      QueryUrl := '$filter=(' + APreparedFilter + ') and (' + TextExpr + ')'
    else
      QueryUrl := '$filter=' + APreparedFilter;
  end
  else
    QueryUrl := '$filter=' + APreparedFilter;

  if Dataset.QueryString <> '' then
    Dataset.QueryString := Dataset.QueryString + '&';
  Dataset.QueryString := Dataset.QueryString + QueryUrl;
end;

procedure TDatasetPlugin.AddExpandQueryUrl(Dataset: TXDataWebDataSet);
var
  Field: TField;
  I: integer;
  QueryUrl, FieldName, ExpandProp: string;
  ExpandProps, rs: TJSArray;
begin
  ExpandProps := TJSArray.new;
  for I := 0 to Dataset.FieldCount - 1 do
  begin
    Field := Dataset.Fields[I];
    if Field is TXDataWebEntityField then
    begin
      FieldName := Field.FieldName;
      ExpandProp := FieldName;
      if not ExpandProps.includes(ExpandProp) then
        ExpandProps.push(ExpandProp);
    end
    else if Pos('.', Field.FieldName) > 0 then
    begin
      FieldName := Field.FieldName;
      rs := TJSArray(TJSString(FieldName).split('.'));
      rs.pop;
      ExpandProp := rs.join('/');
      if not ExpandProps.includes(ExpandProp) then
        ExpandProps.push(ExpandProp);
    end;
  end;

  QueryUrl := ExpandProps.join(',');

  if QueryUrl <> '' then
  begin
    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + '$expand=' + QueryUrl;
  end;
end;

procedure TDatasetPlugin.AddFilterFieldBasedQuery(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; ASearchFields:
  TSearchFields; AFilterText: string; AConstraintText: string);
var
  QueryUrl: string;
  FilterExpressions: TJSArray;
  I: Integer;
  lFieldName, lValue: string;
begin
  FilterExpressions := TJSArray.new;
  for I := 0 to Length(ASearchFields) - 1 do
  begin

    if (ASearchFields[I].FieldLen > 0) and (Length(AFilterText) > ASearchFields[I].FieldLen) then
      lValue := Copy(AFilterText, 1, ASearchFields[I].FieldLen)
    else
      lValue := AFilterText;

    if ASearchFields[I].IsUpperCase then
    begin
      lFieldName := ASearchFields[I].FieldName;
      lValue := Uppercase(lValue);
    end
    else if ASearchFields[I].CaseInsensitive then
    begin
      lFieldName := Format('upper(%s)', [ASearchFields[I].FieldName]);
      lValue := Uppercase(lValue);
    end
    else
    begin
      lFieldName := ASearchFields[I].FieldName;
    end;

    case ASearchFields[I].SearchOperator of
      soStarts:
        FilterExpressions.push(Format('(startswith(%s, ''%s''))', [lFieldName, lValue]));
      soContains:
        FilterExpressions.push(Format('(contains(%s, ''%s''))', [lFieldName, lValue]));
    else
      begin
        if ASearchFields[I].IsNumber then
          FilterExpressions.push(Format('(%s %s %s)', [lFieldName, Operator_Text[ASearchFields[I].SearchOperator], lValue]))
        else
          FilterExpressions.push(Format('(%s %s ''%s'')', [lFieldName, Operator_Text[ASearchFields[I].SearchOperator], lValue]));
      end;
    end;
  end;


  if FilterExpressions.Length > 0 then
  begin
    QueryUrl := '$filter=' + FilterExpressions.join(' or ');
    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + QueryUrl;
  end;

end;

function TDatasetPlugin.BuildColumnFilterExpression(Dataset: TXDataWebDataSet; AGrid: TDBTableControl;
  AFilterText: string; AConstriantText: string): string;

  function FindPropertyType(AEntityType: TXDataEntityType; AName: string): TXDataType;
  var
    NavProp: TXDataNavigationProperty;
  begin
    if Pos('.', AName) > 0 then
    begin
      NavProp := AEntityType.FindNavigationProperty(TJSString(AName).split('.')[0]);
      Result := FindPropertyType(NavProp.Target, Copy(AName, Pos('.', AName) + 1, Length(AName)));
    end
    else
      Result := AEntityType.FindProperty(AName).PropertyType;
  end;

  function NormalizeNumericFilter(const Value: string): string;
  var
    S: string;
  begin
    // Allow Find on displayed money, e.g. £949,363.43 or 949,363
    S := Trim(Value);
    S := StringReplace(S, '£', '', [rfReplaceAll]);
    S := StringReplace(S, ',', '', [rfReplaceAll]);
    S := StringReplace(S, ' ', '', [rfReplaceAll]);
    Result := S;
  end;

  function IsDecimalNumber(const Value: string): Boolean;
  var
    I, StartIdx: Integer;
    SeenDot: Boolean;
  begin
    Result := False;
    if Value = '' then
      Exit;
    StartIdx := 1;
    if Value[1] = '-' then
    begin
      if Length(Value) = 1 then
        Exit;
      StartIdx := 2;
    end;
    SeenDot := False;
    for I := StartIdx to Length(Value) do
    begin
      if Value[I] = '.' then
      begin
        if SeenDot then
          Exit;
        SeenDot := True;
      end
      else if not (Value[I] in ['0'..'9']) then
        Exit;
    end;
    Result := True;
  end;

  function NumericFilterExpression(const AFieldPath, ANormalized: string; AIsFloat: Boolean): string;
  var
    WholePart: string;
    DotPos: Integer;
    NextWhole: Int64;
  begin
    Result := '';
    if AIsFloat then
    begin
      DotPos := Pos('.', ANormalized);
      if DotPos = 0 then
      begin
        // 949363 also matches 949363.43 (integer pounds from the grid display)
        WholePart := ANormalized;
        NextWhole := StrToInt64(WholePart) + 1;
        Result := Format('((%s eq %s) or (%s ge %s and %s lt %d))',
          [AFieldPath, WholePart, AFieldPath, WholePart, AFieldPath, NextWhole]);
      end
      else
        Result := Format('(%s eq %s)', [AFieldPath, ANormalized]);
    end
    else if Pos('.', ANormalized) = 0 then
      Result := Format('(%s eq %s)', [AFieldPath, ANormalized]);
  end;

var
  FilterExpressions: TJSArray;
  Model: TXDataModel;
  EntityType: TXDataEntityType;
  DataField: string;
  Field: TField;
  FieldName: string;
  FieldPath: string;
  Prop: TXDataProperty;
  PropType: TXDataType;
  NumericText: string;
  NumericExpr: string;
  I: integer;
  SkippedOversizedText: Boolean;
begin
  Result := '';
  if AFilterText = '' then
    Exit;
  Model := Dataset.Connection.Model;
  EntityType := Model.FindEntitySet(Dataset.EntitySetName).EntityType;
  FilterExpressions := TJSArray.new;
  NumericText := NormalizeNumericFilter(AFilterText);
  SkippedOversizedText := False;
  for I := 0 to AGrid.Columns.Count - 1 do
  begin
    DataField := AGrid.Columns[I].DataField;
    if DataField = '' then
      Continue;
    Field := Dataset.FieldByName(DataField);
    if Field = nil then
      Continue;
    FieldName := Field.FieldName;
    if Pos('.', FieldName) = 0 then
      Prop := EntityType.FindProperty(FieldName)
    else
      Prop := EntityType.FindNavigationProperty(TJSString(FieldName).split('.')[0]);
    if Prop = nil then
      Continue;
    PropType := FindPropertyType(EntityType, FieldName);
    if PropType = nil then
      Continue;
    FieldPath := string(TJSString(FieldName).replace('.', '/'));
    case PropType.TypeKind of
      TXTypeKind.xtInt16, TXTypeKind.xtInt32, TXTypeKind.xtInt64:
        begin
          if IsDecimalNumber(NumericText) then
          begin
            NumericExpr := NumericFilterExpression(FieldPath, NumericText, False);
            if NumericExpr <> '' then
            begin
              if AConstriantText = '' then
                FilterExpressions.push(NumericExpr)
              else
                FilterExpressions.push(Format('(%s and %s)', [NumericExpr, AConstriantText]));
            end;
          end;
        end;
      TXTypeKind.xtDouble, TXTypeKind.xtCurrency:
        begin
          if IsDecimalNumber(NumericText) then
          begin
            NumericExpr := NumericFilterExpression(FieldPath, NumericText, True);
            if NumericExpr <> '' then
            begin
              if AConstriantText = '' then
                FilterExpressions.push(NumericExpr)
              else
                FilterExpressions.push(Format('(%s and %s)', [NumericExpr, AConstriantText]));
            end;
          end;
        end;
      TXTypeKind.xtText:
        begin
          if isString(AFilterText) then
          begin
            if (Field.Size > 0) and (Length(AFilterText) > Field.Size) then
              SkippedOversizedText := True
            else if AConstriantText = '' then
              FilterExpressions.push(Format('(contains(%s, ''%s''))', [FieldPath, AFilterText]))
            else
              FilterExpressions.push(Format('(contains(%s, ''%s'') and %s)', [FieldPath, AFilterText, AConstriantText]));
          end;
        end;
    end;
  end;

  if FilterExpressions.Length > 0 then
    Result := string(FilterExpressions.join(' or '))
  else if SkippedOversizedText then
    Result := '(1 eq 0)';
end;

procedure TDatasetPlugin.AddFilterQueryUrl(Dataset: TXDataWebDataSet; AGrid: TDBTableControl; AFilterText: string; AConstriantText: string);
var
  QueryUrl: string;
  FilterExpr: string;
begin
  FilterExpr := BuildColumnFilterExpression(Dataset, AGrid, AFilterText, AConstriantText);
  if FilterExpr = '' then
    Exit;

  QueryUrl := '$filter=' + FilterExpr;
  if Dataset.QueryString <> '' then
    Dataset.QueryString := Dataset.QueryString + '&';
  Dataset.QueryString := Dataset.QueryString + QueryUrl;
end;

procedure TDatasetPlugin.AddOrderByQueryUrl(Dataset: TXDataWebDataSet; SortedItems: TSortedItems);
var
  I: integer;
  QueryUrl: string;
  OrderInfo: TOrderInfo;
  OrderProps: array of string;
begin
  SetLength(OrderProps, Length(SortedItems));
  for I := 0 to Length(SortedItems) - 1 do
  begin
    OrderInfo := SortedItems[I];
    if OrderInfo.Ascending then
      OrderProps[I] := OrderInfo.FieldName + ' asc'
    else
      OrderProps[I] := OrderInfo.FieldName + ' desc';
    OrderProps[I] := StringReplace(OrderProps[I], '.', '/', [rfReplaceAll]);
  end;

  QueryUrl := TJSArray(OrderProps).join(',');

  if QueryUrl <> '' then
  begin
    if Dataset.QueryString <> '' then
      Dataset.QueryString := Dataset.QueryString + '&';
    Dataset.QueryString := Dataset.QueryString + '$orderby=' + QueryUrl;
  end;
end;

constructor TDatasetPlugin.Create(ADataset: TXDataWebDataSet; ALoadCallback: TOnLoad);
begin
  FDataset := ADataset;
  FOriginalQuery := FDataset.QueryString;
  FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
  FPageSize := 0;
  FPageNumber := 0;

  FOnLoad := ALoadCallback;
  FOriginalAfterOpen := FDataset.AfterOpen;
  FDataset.AfterOpen := InternalAfterOpen;
end;

function TDatasetPlugin.GetServerRecordCount: Integer;
begin
  Result := FDataset.ServerRecordCount;
end;

procedure TDatasetPlugin.InternalAfterOpen(ADataset: TDataSet);
begin
  try
    if Assigned(FOnLoad) then
      FOnLoad(Self);
    if Assigned(FOriginalAfterOpen) then
      FOriginalAfterOpen(ADataset);
  finally
    FDataset.EnableControls;
  end;
end;

function TDatasetPlugin.IsLastPage: Boolean;
begin
  if PageSize = 0 then
    Result := True
  else
    Result := (PageNumber * PageSize) >= FDataset.ServerRecordCount;
end;

procedure TDatasetPlugin.LoadDataset(GridSettings: TGridSettings);

  { Navigation paths need Foo.Bar -> Foo/Bar, but must not rewrite decimal
    literals (949363.43) or dots inside quoted strings (file.csv). }
  function ConvertPropertyPathDots(const Query: string): string;
  var
    I: Integer;
    InQuote: Boolean;
    Ch, Prev, NextCh: Char;
  begin
    Result := '';
    InQuote := False;
    I := 1;
    while I <= Length(Query) do
    begin
      Ch := Query[I];
      if Ch = '''' then
      begin
        Result := Result + Ch;
        if InQuote and (I < Length(Query)) and (Query[I + 1] = '''') then
        begin
          Result := Result + '''';
          Inc(I);
        end
        else
          InQuote := not InQuote;
      end
      else if (Ch = '.') and not InQuote then
      begin
        Prev := #0;
        NextCh := #0;
        if I > 1 then
          Prev := Query[I - 1];
        if I < Length(Query) then
          NextCh := Query[I + 1];
        if (Prev in ['0'..'9']) and (NextCh in ['0'..'9']) then
          Result := Result + '.'
        else
          Result := Result + '/';
      end
      else
        Result := Result + Ch;
      Inc(I);
    end;
  end;

begin
  // A failed/cancelled async Load never reaches AfterOpen, so DisableControls can
  // stick. Pagination still updates (uses ServerRecordCount) but TWebDBTableControl
  // skips painting while ControlsDisabled.
  while FDataset.ControlsDisabled do
    FDataset.EnableControls;

  FDataset.DisableControls;
  try
    FDataSet.Close;
    FDataSet.QueryString := FOriginalQuery;

    AddPaginationQueryUrl(FDataSet, PageNumber, PageSize);
    AddExpandQueryUrl(FDataSet);
    if GridSettings.PreparedSearch <> '' then
      AddPreparedFilter(FDataset, GridSettings.Grid, GridSettings.PreparedSearch, GridSettings.FilterText)
    else if GridSettings.SpecificSearch then
      AddFilterFieldBasedQuery(FDataset, GridSettings.Grid, GridSettings.SearchFields, GridSettings.FilterText)
    else if GridSettings.ConstraintSearch <> '' then
      AddFilterQueryUrl(FDataSet, GridSettings.Grid, GridSettings.FilterText, GridSettings.ConstraintSearch)
    else
      AddFilterQueryUrl(FDataSet, GridSettings.Grid, GridSettings.FilterText);

    AddOrderByQueryUrl(FDataSet, GridSettings.SortedItems);
    FDataSet.QueryString := ConvertPropertyPathDots(FDataSet.QueryString);

    FDataSet.Load;
  except
    FDataset.EnableControls;
    raise;
  end;
end;

function TDatasetPlugin.NextPage: Boolean;
begin
  Result := not IsLastPage;
  if Result then
    FPageNumber := FPageNumber + 1;
end;

function TDatasetPlugin.PreviousPage: Boolean;
begin
  Result := False;
  if FPageNumber > 1 then
  begin
    FPageNumber := FPageNumber - 1;
    Result := True;
  end;
end;

procedure TDatasetPlugin.SetPageNumber(const Value: Integer);
begin
  FPageNumber := Value;
  if FPageNumber > 0 then
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smInlineCount
  else
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
end;

procedure TDatasetPlugin.SetPageSize(const Value: Integer);
begin
  FPageSize := Value;
  if FPageSize > 0 then
  begin
    FPageNumber := 1;
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smInlineCount;
  end
  else
  begin
    FPageNumber := 0;
    FDataset.ServerRecordCountMode := TServerRecordCountMode.smNone;
  end;
end;

end.

